module.exports = __webpack_public_path__ + "img/chart-blue.57387b62.png";